<template>
  <b-modal scrollable :title="getShoppingCartTitle()" id="modal" ref="modal">
    <div class="modal-body" style="width: 100%">
      <b-row>
        <b-col cols="12" class="pl-0 pr-0">
          <b-row style="" hidden>
            <b-col cols="12" align-self="center" class="">
              <b-row hidden>
                <b style="font-size: 24px; font-weight: 600" class="h2-font"
                  >Your Truthbrush</b
                >
              </b-row>
              <b-row class="pt-2">
                <b-col class="pl-0 pr-0">
                  <b>Free US shipping of $50 and above.</b>
                </b-col>
              </b-row>
              
            </b-col>
          </b-row>
          <b-row hidden>
            <b-col cols="12" class="pl-0 pr-0">
              <hr style="border: 0.5px solid #d9dadb; margin-left: 0" />
            </b-col>
          </b-row>
          <b-row v-if="filteroptions().length > 0">
            <b-col style="font-size: 14px; font-weight: 600" class="">
              Add {{ getExtraName() }}
            </b-col>
          </b-row>
          <b-row class="pt-1" v-if="filteroptions().length > 0">
            <b-col>
              <b-row>
                <b-col
                  style="max-width: 14.2%; cursor: pointer"
                  v-for="(item, index) in filteroptions()"
                  v-bind:key="item.id"
                  class="pl-0 pr-0"
                  @mouseover="setUnderline(index, true)"
                  @click="addSku(item)"
                  :class="{ underlinestyle: getextrasensorclass(index) }"
                >
                  <b-img fluid :src="item.metadata.image0"></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-if="filteroptions().length > 0">
            <b-col cols="12" class="pl-0 pr-0">
              <hr style="border: 0.5px solid #d9dadb; margin-left: 0" />
            </b-col>
          </b-row>
          <b-row
            v-for="(item, index) in getselectedsku()"
            v-bind:key="item.sku.skutitle"
            align-h="between"
          >
            <b-col cols="4" class="pl-1 pr-1 more-bottom-padding-small pl-0 pr-0">
              <b-img
                :src="getSwatch(item.sku)"
                fluid
                class="swatch_small_single_display_skin"
                v-if="item.sku.productid == 'prod_0000'"
                center
              >
              </b-img>
              <b-img
                :src="getSwatch(item.sku)"
                fluid
                class="swatch_small_single_display"
                v-else
                center
              >
              </b-img>
            </b-col>
            <b-col cols="6" align-self="center" class="pl-0 pr-0">
              <b-row class="pb-0">
                <div style="font-size: 16px; line-height: 1.2" class="h4-font">
                  {{
                    item.sku.productname +
                    " (" +
                    item.sku.attributes.Style +
                    ")"
                  }}
                </div>
              </b-row>
              <b-row class="pt-3">
                <b-col cols="6" class="pl-0 pr-0">
                  <b-row>
                    <b-col cols="3" align-self="center" class="pl-0 pr-0">
                      <b-button
                        style="
                          border-radius: 25px !important;
                          width: 25px;
                          height: 25px;
                        "
                        variant="outline-secondary"
                        size="sm"
                        @click="addItem(item, -1)"
                      >
                        -
                      </b-button>
                    </b-col>

                    <b-col
                      cols="6"
                      align-self="center"
                      style="text-align: center"
                    >
                      {{ item.quantity }}
                    </b-col>

                    <b-col cols="3" align-self="center" class="pl-0 pr-0">
                      <b-button
                        style="
                          border-radius: 25px !important;
                          width: 25px;
                          height: 25px;
                        "
                        size="sm"
                        @click="addItem(item, +1)"
                      >
                        +
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="6"
                  style="text-align: right"
                  class="pr-0"
                  align-self="center"
                >
                  <b-row>
                    <b-col>
                      ${{ ((item.sku.price * item.quantity) / 100).toFixed(2) }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="2" class="more-bottom-padding-small">
              <button
                type="button"
                class="close"
                @click="deletesku(item.sku)"
                style="color: black; border-color: transparent !important"
              >
                ×
              </button>
            </b-col>

            <b-col
              cols="12"
              class="pl-0 pr-0"
              v-if="index < getskuquantitylistlength() - 1"
            >
              <hr style="border: 0.5px solid #d9dadb; margin-left: 0" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer>
      <b-container class="pl-0 pr-0">
        <b-row
          v-if="
            getdiscountedtotalprice(false, false) -
              getdiscountedtotalprice(true, true) >
            0.1
          "
        >
          <b-col cols="6" class="pl-0" align-self="center">
            <b style="font-size: 16px">Coupon Discount</b>
          </b-col>
          <b-col
            class="pr-0"
            style="text-align: right; font-size: 20px"
            align-self="center"
          >
            <b
              ><s>$ {{ getdiscountedtotalprice(false, false) }}</s> ($-{{
                (
                  getdiscountedtotalprice(false, false) -
                  getdiscountedtotalprice(true, true)
                ).toFixed(2)
              }})
            </b>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="7" class="pl-0" style="font-size: 20px">
            <b style="font-size: 20px">Subtotal</b>
          </b-col>
          <b-col class="pr-0" style="text-align: right">
            <b style="font-size: 20px"
              >$ {{ getdiscountedtotalprice(true, true) }}</b
            >
          </b-col>
        </b-row>
        <b-row class="pt-1 pb-1" v-if="show_pay_in_4">
          <b-col class="pl-0 pr-0">
            <b style='color:#C84141'>4 payments of ${{(getdiscountedtotalprice(true, true)/4.0).toFixed(2)}}, </b>interest free with PayPal
          </b-col>
        </b-row>
        
        <b-row class="pt-1">
          <b-col md="12" class="pl-0 pr-0" ref="paypalbutton">
            <div id="paypal_button_container" ref="paypalbutton"></div>
          </b-col>
        </b-row>

        <b-row class="pt-2 pb-1">
          <b-col md="12" class="pl-0 pr-0" ref="stripe_button_container">
            <div
              id="stripe_button_container"
              ref="stripe_button_container"
            ></div>
          </b-col>
        </b-row>

        <b-row class="pt-1">
          <b-col md="12" class="pl-0 pr-0">
            <b-button
              pill
              class="blue-button"
              style="height: 40px; width: 100%; border-radius: 4px !important"
              v-on:click="onAddCart2()"
            >
              <span style="font-size: 18px">Pay with Credit/Debit Card</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="pt-2" hidden>
          <b-col cols="1" style="min-width: 50px" class="pl-0 pr-0 pt-2">
            <b-img src="img/visa@2x.png" style="width: 40px"></b-img>
          </b-col>
          <b-col cols="1" style="min-width: 50px" class="pl-0 pr-0 pt-2">
            <b-img src="img/master-card@2x.png" style="width: 40px"></b-img>
          </b-col>
          <b-col cols="1" style="min-width: 50px" class="pl-0 pr-0 pt-2">
            <b-img src="img/discover@2x.png" style="width: 40px"></b-img>
          </b-col>
          <b-col cols="1" style="min-width: 50px" class="pl-0 pr-0 pt-2">
            <b-img
              src="img/american-express@2x.png"
              style="width: 40px"
            ></b-img>
          </b-col>
          <b-col cols="1" style="min-width: 50px" class="pl-0 pr-0 pt-2">
            <b-img src="img/jcb@2x.png" style="width: 40px"></b-img>
          </b-col>
          <b-col cols="1" style="min-width: 50px" class="pl-0 pr-0 pt-2">
            <b-img src="img/unionPay.png" style="width: 35px"></b-img>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import storage from "../storage";
import store from "../store";
export default {
  name: "Checkout-Express",
  data() {
    return {
      show_pay_in_4: true
    };
  },
  methods: {
    showExpressCheckout() {
      this.$refs.modal.show();
    },
    gotoskin() {
      this.$refs["modal"].hide();
      window.location.href = "/#/select_t3";
    },

    getPaypalButton() {
      return this.$refs.paypalbutton;
    },
    getStripeButton() {
      return this.$refs.stripe_button_container;
    },
    setUnderline(index, val) {
      store.state.extrasensorclass = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      store.state.extrasensorclass[index] = val;
    },
    getextrasensorclass(index) {
      return store.state.extrasensorclass[index];
    },
    getShoppingCartTitle() {
      return "Shopping Cart (" + store.state.cartlength + ")";
    },
    gettotaltracker() {
      var tracker = 0;
      for (
        var i = 0;
        store.state.skuquantitylist.selectedsku != null &&
        i < store.state.skuquantitylist.selectedsku.length;
        i++
      ) {
        if (
          store.state.skuquantitylist.selectedsku[i].sku.productid ==
            "prod_0001" ||
          store.state.skuquantitylist.selectedsku[i].sku.productid ==
            "prod_0003" ||
          store.state.skuquantitylist.selectedsku[i].sku.productid ==
            "prod_0004"
        ) {
          tracker += store.state.skuquantitylist.selectedsku[i].quantity;
        }
      }

      return tracker;
    },

    gettotalhub() {
      var hub = 0;
      for (
        var i = 0;
        store.state.skuquantitylist.selectedsku != null &&
        i < store.state.skuquantitylist.selectedsku.length;
        i++
      ) {
        if (
          store.state.skuquantitylist.selectedsku[i].sku.productid ==
          "prod_0002"
        ) {
          hub += store.state.skuquantitylist.selectedsku[i].quantity;
        }
      }

      return hub;
    },
    addSku(sku) {
      storage.inseirtSku_Quantity_to_Store(sku, 1);
      storage.saveStore2Cart();
    },

    addItem(item, direction) {
      item.quantity += direction;

      if (item.quantity <= 0) {
        this.deletesku(item.sku);
      } else {
        storage.saveStore2Cart();
      }

      storage.updatecartlen();
      this.getproductname();
    },

    deletesku(sku) {
      storage.deletesku_from_store(sku);
      storage.saveStore2Cart();
      //this.updateInfo();
      this.getproductname();
      if(storage.is_subscription_item_in_cart()){
        this.show_pay_in_4 = false;
      }else{
        this.show_pay_in_4 = true;
      }
      if(sku.id.includes("sku_activation_")){
        if(!storage.is_subscription_item_in_cart()){
          storage.updatePayPayButton(null, null);
        }
      }
      if (store.state.skuquantitylist.selectedsku.length == 0) {
        this.$refs["modal"].hide();
      }
      
    },
    getskuquantitylistlength() {
      if (
        this.$store.state.skuquantitylist == null ||
        this.$store.state.skuquantitylist.selectedsku == null
      ) {
        return 0;
      }
      return this.$store.state.skuquantitylist.selectedsku.length;
    },
    getSwatch(sku) {
      if(sku.metadata==null){
        return "";
      }
      return sku.metadata.image0;
    },

    getproductname() {
      return storage.getproductname();
    },
    onAddCart1() {
      
      window.location.href = "/#/select";
    },
    onAddCart2() {
      
      storage.reportInitCheckout(this.getdiscountedtotalprice(true, true));
      window.location.href = "/#/cart?state=1";
    },
    getExtraName() {
      var foundhub = 0;
      var foundtracker = 0;
      for (var i = 0; i < store.state.skuquantitylist.selectedsku.length; i++) {
        var sku = store.state.skuquantitylist.selectedsku[i].sku;
        if (sku.productid == "prod_0004" || sku.productid == "prod_0001" || sku.productid == "prod_0003") {
          foundtracker++;
        } else if (sku.productid == "prod_0002"){
          foundhub++;
        }
      }
      //console.log(foundhub+" "+foundtracker)
      if (foundhub == 0 && foundtracker < 7) {
        return "Extra Tracker Or Hub";
      } else if (foundhub == 0) {
        return "A Hub";
      } else {
        return "Extra Tracker";
      }
    },
    speelplural(q, word) {
      if (q <= 1) {
        return word;
      } else {
        return word + "s";
      }
    },
    filteroptions() {
      var array = [];
      /*
      for (var i = 0; i < store.state.skulist.length; i++) {
        var sku = store.state.skulist[i];
        if (sku.productid == "prod_0002" || sku.productid == "prod_0004" || sku.productid == "prod_0003") { // shortcut does not show prod_0001
          //var found = false;
          for (
            var j = 0;
            j < store.state.skuquantitylist.selectedsku.length;
            j++
          ) {
            var sku2 = store.state.skuquantitylist.selectedsku[j].sku;
            if (sku2.id == sku.id) {
            //  found = true;
              break;
            }
          }
            array.push(sku);
        }
      }
      */
      return array;
    },
    getselectedsku() {
      var list = [];
      if (
        store.state.skuquantitylist != null &&
        store.state.skuquantitylist.selectedsku != null
      ) {
        return store.state.skuquantitylist.selectedsku;
      }

      return list;
    },
    addHub(quantity) {
      for (var j = 0; j < store.state.skulist.length; j++) {
        var sku = store.state.skulist[j];
        if (sku.productid == "prod_0002") {
          storage.inseirtSku_Quantity_to_Store(sku, quantity);
          storage.saveStore2Cart();
          break;
        }
      }
    },
    getdiscountedtotalprice(bundle, coupon) {
      return storage.calculateBundleDiscount(bundle, coupon);
    },
  },
  mounted() {
    if(storage.is_subscription_item_in_cart()){
      this.show_pay_in_4 = false;
    }else{
      this.show_pay_in_4 = true;
    }
  },
};
</script>

<style lang="scss">
</style>

